import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}


export type PaymentFrequency = 'monthly' | 'quarterly' | 'halfYearly' | 'yearly';

export interface ContractPayment {
  paymentAmount: number | null;
  paymentFrequency: PaymentFrequency | null;
}

/**
 * Normalize a payment to monthly or yearly
 */
export const normalizePayment = (
  amount: number | null,
  frequency: PaymentFrequency | null,
  target: 'monthly' | 'yearly' = 'monthly'
): number => {
  if (!amount || !frequency) return 0;

  let monthlyAmount = 0;

  switch (frequency) {
    case 'monthly':
      monthlyAmount = amount;
      break;
    case 'quarterly':
      monthlyAmount = amount / 3;
      break;
    case 'halfYearly':
      monthlyAmount = amount / 6;
      break;
    case 'yearly':
      monthlyAmount = amount / 12;
      break;
    default:
      monthlyAmount = amount;
  }

  return target === 'monthly' ? monthlyAmount : monthlyAmount * 12;
};
